<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { TYPE_IMG, TYPE_VIDEO, TYPE_STORY } from '@/composables/memorize/memorize'
import { titleBar } from '@/composables/menu/title'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  serviceId: {
    type: String,
    required: true
  },
  titleClass: {
    type: String,
    required: false,
    default: ''
  }
})

const router = useRouter()

const serviceId = computed(() => props.serviceId)

function onMenuClicked() {
  switch (props.name) {
    case 'add_ones_life':
      router.push('/addOnesLife?serviceId=' + serviceId.value + '&name=' + titleBar.value?.life?.name.fullName)
      break
    case 'add_picture':
      router.push(
        `/addPhoto?type=${TYPE_IMG}&serviceId=` + serviceId.value + '&name=' + titleBar.value?.life?.name.fullName
      )
      break
    case 'add_video':
      router.push(
        `/addPhoto?type=${TYPE_VIDEO}&serviceId=` + serviceId.value + '&name=' + titleBar.value?.life?.name.fullName
      )
      break
    case 'add_story':
      router.push(
        `/addPhoto?type=${TYPE_STORY}&serviceId=` + serviceId.value + '&name=' + titleBar.value?.life?.name.fullName
      )
      break
    case 'add_memorize':
      router.push('/addMemorize?serviceId=' + serviceId.value + '&name=' + titleBar.value?.life?.name.fullName)
      break
    default:
      break
  }
}
</script>
<template>
  <div
    flex="~ row"
    z-10
    text-second
    fixed
    bottom-2
    border-0
    right-4
    class="m-0 safe-margin"
    md:static
    md:rounded-2
    md:bg-transparent
    md:border-1
    shadow-lg
    md:shadow-none
    rounded-full
    items-center
    cursor-pointer
    transition-all
    duration-150
    btn-theme-solid
    md:btn-theme-outline
    text-theme-inverted
    md:text-theme-dark
    @click="onMenuClicked">
    <slot></slot>
    <span :class="props.titleClass">{{ props.title }}</span>
  </div>
</template>
<style lang="scss" scoped>
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .safe-margin {
    margin-bottom: constant(safe-area-inset-bottom);
    margin-bottom: env(safe-area-inset-bottom);
    transition: margin-bottom 0.3s ease;
  }
}
</style>
